<template>
    <div class="main">
        <div class="title">
            <div class="name">专家预约信息</div>
            <div class="btn" @click="$router.back()">
                <img alt="" src="../../../assets/images/back.png">
                返回
            </div>
        </div>

        <div class="box">
            <div class="detail">
                <div class="img">
                    <img :src="urlStr + detail.pic" alt="">
                </div>
                <div class="cont">
                    <div class="name-box">
                        <div class="name">
                            <b>{{ detail.name }}</b>
                            <i>|</i>
                            <span>{{ detail.type_name }}</span>
                        </div>
                        <div>
                            <div class="num-box">
                                <p>预约总数<b>{{ detail.yuyue_all_count }}</b></p>
                                <span>|</span>
                                <p>待处理数<b>{{ detail.yuyue_count }}</b></p>
                            </div>
                            <div class="num-box">
                                <p>内部预约<b>{{ detail.yuyue_nei_count }}</b></p>
                                <span>|</span>
                                <p>外部预约<b>{{ detail.yuyue_wai_count }}</b></p>
                            </div>
                        </div>
                    </div>
                    <div class="tex ovHide">{{ detail.job_text }}</div>
                    <div class="xian"></div>
                    <div class="tex ovHide2" v-html="detail.desc"></div>
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 20px;"></div>

        <div class="box">
            <div class="search-box">
                <div class="input-box">
                    <el-input v-model="input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
                    <div @click="listFun">
                        <i class="iconfont icon-sousuo"></i>
                        <span>搜索</span>
                    </div>
                </div>
            </div>
            <div class="tabs">
                <el-radio-group v-model="tabPosition" style="margin-bottom: 20px;" @change="tabChange">
                    <el-radio-button :label="1">内部预约</el-radio-button>
                    <el-radio-button :label="2">外部预约</el-radio-button>
                </el-radio-group>
            </div>
            <!--    内部预约  -->
            <div v-if="tabPosition == 1">
                <el-table
                    :cell-style="{'text-align':'center'}"
                    :data="List"
                    :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
                    border
                    style="width: 100%;border-radius: 10px;">
                    <el-table-column
                        label="预约人"
                        prop="name">
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        prop="create_time" width="160">
                    </el-table-column>
                    <el-table-column
                        label="手机号"
                        prop="phone" width="120">
                    </el-table-column>
                    <el-table-column
                        label="项目名称"
                        prop="project_name">
                    </el-table-column>
                    <el-table-column
                        label="活动主题"
                        prop="event_theme">
                    </el-table-column>
                    <el-table-column
                        label="天数"
                        prop="day">
                    </el-table-column>
                    <el-table-column
                        label="劳务费类别"
                        prop="fees_type" width="160">
                    </el-table-column>
                    <el-table-column
                        label="劳务金额"
                        prop="fees">
                    </el-table-column>
                    <el-table-column
                        label="评价内容"
                        prop="evaluate">
                    </el-table-column>
                    <el-table-column
                        label="评价时间"
                        prop="evaluate_time" width="160">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="160">
                        <template slot-scope="scope">
                            <el-button
                                v-if="tabPosition == 1"
                                class="del"
                                round
                                size="small"
                                @click="toDetail(scope.row.id)">详情
                            </el-button>
                            <el-button
                                v-if="Number(scope.row.status) === 0"
                                class="del"
                                round
                                size="small"
                                @click="changeFun(scope.row.id)">处理
                            </el-button>
                            <el-button
                                class="edit"
                                round
                                size="small"
                                type="primary"
                                @click="del(scope.row.id)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="tabPosition == 2" class="list">
                <div v-for="item in List" :key="item.id" class="item">
                    <div class="item-name">
                        <div class="iten-b">{{ item.name }}</div>
                        <div class="item-r">
                            <span v-if="Number(item.status) === 1 && tabPosition == 2" class="s3">已处理</span>
                        </div>
                    </div>
                    <div class="text">
                        <span>申请时间：</span>
                        <span>{{ item.create_time }}</span>
                    </div>
                    <div class="text">
                        <span>联系电话：</span>
                        <span>{{ item.phone }}</span>
                    </div>
                    <div class="text">
                        <span>{{ tabPosition == 1 ? '项目名称' : '申请内容' }}：</span>
                        <span class="ovHide2">{{ tabPosition == 1 ? item.project_name : item.content }}</span>
                    </div>
                    <div class="item-btn">
                        <span v-if="tabPosition == 1" class="btn1" @click="toDetail(item.id)">详情</span>
                        <span v-if="Number(item.status) === 0" class="btn1" @click="changeFun(item.id)">处理</span>
                        <span v-if="Number(item.status) === 1" class="btn1" @click="del(item.id)">删除</span>
                    </div>
                </div>
            </div>
            <el-empty v-if="List.length == 0" :image-size="200" style="margin: 0 auto"></el-empty>
            <div v-else class="page-box">
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next"
                    @current-change="listFun">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {changeStatus, delInternalYuyue, delYuyue, expertInternalYuyue, expertYuyue, getExpert} from "@/api/index";
import {urlStr} from "@/config";

export default {
    name: "detail",
    data() {
        return {
            urlStr: urlStr,
            tabPosition: 1,
            id: '',
            input: '',
            detail: {},
            List: [],
            page: 1,
            limit: 12,
            total: 0,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    created() {
        this.$emit("setActive", {
            active: 1,
            act: 2,
            name: '专家管理 > 专家信息 > 预约信息'
        })
        this.id = this.$route.query.id
        this.detailFun()
        this.listFun()
    },
    methods: {
        tabChange() {
            this.List = []
            this.page = 1
            this.listFun()
        },
        // 获取列表
        async listFun() {
            let _res;
            if (this.tabPosition == 1) {
                _res = await expertInternalYuyue(
                    this.user.mid,
                    this.id,
                    this.input,
                    this.page, this.limit
                );
            } else {
                _res = await expertYuyue(
                    this.user.mid,
                    this.id,
                    this.input,
                    this.page, this.limit
                );
            }
            if (_res.status === 200) {
                this.total = _res.total_number
                this.List = _res.data.list
            } else {
                this.$message.error(_res.msg)
            }
        },

        // 获取专家详情
        async detailFun() {
            let _res = await getExpert(
                this.user.mid,
                this.id
            );
            if (_res.status === 200) {
                this.detail = _res.data
                let ary = JSON.parse(this.detail.job)
                let arr = []
                ary.map(itm => {
                    arr.push(itm.value)
                })
                this.detail.job_text = arr.join('、')
            } else {
                this.$message.error(_res.msg)
            }
        },
        // 处理预约 外部
        async changeFun(id) {
            let _res = await changeStatus(
                this.user.mid, id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg)
                this.listFun()
            } else {
                this.$message.error(_res.msg)
            }
        },

        del(id) {
            this.tabPosition == 1 ? this.delInternalFun(id) : this.delFun(id)
        },
        // 删除预约 外部
        async delFun(id) {
            let _res = await delYuyue(
                this.user.mid, id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg)
                this.listFun()
            } else {
                this.$message.error(_res.msg)
            }
        },
        // 删除预约 内部
        async delInternalFun(id) {
            let _res = await delInternalYuyue(
                this.user.mid, id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg)
                this.listFun()
            } else {
                this.$message.error(_res.msg)
            }
        },
        toDetail(id) {
            this.$router.push({
                path: '/home/examineYuyue',
                query: {
                    detailId: id,
                    id:this.id
                }
            })
        },

    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>

.main {
    display: flex;
    flex-direction: column;

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 8px 15px 8px;

        .name {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
        }

        .btn {
            width: 100px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            letter-spacing: 1px;
            color: #0a2240;
            cursor: pointer;

            img {
                width: 14px;
                height: 12px;
                margin-right: 2px;
            }
        }
    }

    .box {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        flex: 1;

        .list {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            .item {
                width: 305px;
                height: 240px;
                background-color: #ffffff;
                border-radius: 10px;
                border: solid 1px #dae0e6;
                padding: 15px;
                margin-right: 20px;
                margin-bottom: 20px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .text {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin-top: 15px;

                    span:first-child {
                        width: 75px;
                        font-size: 14px;
                        color: #666666;
                    }

                    span:last-child {
                        flex: 1;
                        width: 0;
                        font-size: 14px;
                        color: #666666;
                    }
                }

                .item-btn {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 15px;

                    .btn1 {
                        width: 70px;
                        height: 30px;
                        background-color: #0a2240;
                        border-radius: 15px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 14px;
                        letter-spacing: 1px;
                        color: #ffffff;
                        cursor: pointer;
                        margin: 0 5px;
                    }

                    .btn2 {
                        width: 70px;
                        height: 30px;
                        background-color: #ffffff;
                        border-radius: 15px;
                        border: solid 1px #0a2240;
                        line-height: 28px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #0a2240;
                        font-size: 14px;
                        cursor: pointer;
                        margin-left: 5px;
                        margin: 0 5px;
                    }
                }

                .item-name {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #eeeeee;

                    .iten-b {
                        font-size: 20px;
                        color: #333333;
                        font-weight: bold;
                    }

                    .item-r {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .s1 {
                            width: 70px;
                            height: 30px;
                            background-color: #0a2240;
                            border-radius: 15px;
                            text-align: center;
                            line-height: 30px;
                            font-size: 14px;
                            letter-spacing: 1px;
                            color: #ffffff;
                            cursor: pointer;
                        }

                        .s2 {
                            width: 70px;
                            height: 30px;
                            background-color: #ffffff;
                            border-radius: 15px;
                            border: solid 1px #0a2240;
                            line-height: 28px;
                            text-align: center;
                            letter-spacing: 1px;
                            color: #0a2240;
                            font-size: 14px;
                            cursor: pointer;
                            margin-left: 5px;
                        }

                        .s3 {
                            font-size: 14px;
                            letter-spacing: 1px;
                            color: #999999;
                            margin-right: 5px;
                        }
                    }
                }
            }
        }

        .search-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            .select-box {
                width: 162px;
            }

            .chongz {
                width: 99px;
                height: 40px;
                background-color: #0a2240;
                border-radius: 5px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
                text-align: center;
                line-height: 40px;
            }

            .input-box {
                flex: 1;
                width: 0;
                display: flex;
                height: 40px;
                overflow: hidden;
                justify-content: space-between;
                border-radius: 5px;

                > div {
                    width: 100px;
                    height: 40px;
                    background-color: #0a2240;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    span {
                        font-size: 16px;
                        color: #ffffff;
                    }

                    i {
                        margin-right: 4px;
                        color: #ffffff;
                        font-size: 18px;
                    }
                }
            }
        }

        .detail {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .img {
                width: 127px;
                height: 154px;
                background-color: #eaeff3;
                border-radius: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
            }

            .cont {
                flex: 1;
                width: 0;
                margin-left: 27px;

                .name-box {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;

                    .name {
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        b {
                            font-size: 28px;
                            letter-spacing: 1px;
                            color: #333333;
                            font-weight: bold;
                        }

                        i {
                            color: #e2e2e2;
                            margin: 0 20px;
                        }

                        span {
                            font-size: 18px;
                            letter-spacing: 1px;
                            color: #333333;
                        }
                    }

                    .num-box {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        flex-wrap: wrap;

                        p {
                            font-size: 16px;
                            color: #0a2240;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            b {
                                font-size: 20px;
                                color: #ff9600;
                                font-weight: bold;
                                margin-left: 20px;
                            }
                        }

                        span {
                            color: #e2e2e2;
                            margin: 0 20px;
                        }
                    }
                }

                .tex {
                    width: 100%;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                }

                .xian {
                    width: 100%;
                    height: 1px;
                    background-color: #eaeaea;
                    margin: 15px 0;
                }
            }
        }
    }
}
</style>


